module.exports = __webpack_public_path__ + "static/Hamburger-38a9ddabeb0112de354d7dc160f25335.png";